'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCard = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _markdown = require('helpers/markdown');

var _verify = require('helpers/verify');

var _CmsModules = require('containers/CmsPage/CmsModules');

var _DocumentLevel = require('components/CmsPage/modules/DocumentLevel/DocumentLevel');

var _Heading = require('components/CmsPage/modules/Heading/Heading');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductCard = exports.ProductCard = function ProductCard(props) {
  var cmsModuleId = props.cmsModuleId,
      callout = props.callout,
      calloutNote = props.calloutNote,
      ctaCopy = props.ctaCopy,
      details = props.details,
      disclaimer = props.disclaimer,
      modules = props.modules,
      extraClass = props.extraClass,
      tag = props.tag,
      url = props.url;


  return _react2.default.createElement(
    'div',
    { className: 'ProductCard__wrapper' },
    _react2.default.createElement(
      _reactRouter.Link,
      { to: url || '', className: 'ProductCard__link' },
      _react2.default.createElement(
        _DocumentLevel.NestDocumentLevel,
        null,
        _react2.default.createElement(
          'section',
          { className: (0, _classnames2.default)('ProductCard', extraClass) },
          _react2.default.createElement(
            'header',
            null,
            tag && _react2.default.createElement(
              'div',
              { className: 'ProductCard__tag' },
              _react2.default.createElement(
                'span',
                null,
                tag
              )
            ),
            _react2.default.createElement(_Heading.HeadingTag, { className: 'ProductCard__callout', title: callout }),
            calloutNote && _react2.default.createElement(
              'p',
              { className: 'ProductCard__note' },
              (0, _markdown.renderMarkdown)(calloutNote, 'ProductCard:Note:' + cmsModuleId)
            )
          ),
          details && (0, _verify.isEmpty)(modules) && _react2.default.createElement(
            'div',
            { className: 'ProductCard__details' },
            (0, _markdown.renderMarkdown)(details, 'ProductCard:Details:' + cmsModuleId)
          ),
          !(0, _verify.isEmpty)(modules) && _react2.default.createElement(
            'div',
            { className: 'ProductCard__content' },
            _react2.default.createElement(_CmsModules.CmsModules, { modules: modules })
          ),
          _react2.default.createElement(
            'div',
            { className: 'ProductCard__cta' },
            _react2.default.createElement(
              'button',
              { className: 'bt bt--primary bt--lg bt--width-full' },
              ctaCopy
            )
          )
        )
      )
    ),
    disclaimer && _react2.default.createElement(
      'p',
      { className: 'ProductCard__disclaimer' },
      disclaimer
    )
  );
};

ProductCard.propTypes = {
  callout: _propTypes2.default.node.isRequired,
  calloutNote: _propTypes2.default.node,
  cmsModuleId: _propTypes2.default.string.isRequired,
  ctaCopy: _propTypes2.default.node.isRequired,
  details: _propTypes2.default.node,
  disclaimer: _propTypes2.default.node,
  extraClass: _propTypes2.default.string,
  modules: _propTypes2.default.arrayOf(_CmsModules.CmsModuleShape),
  tag: _propTypes2.default.node,
  url: _propTypes2.default.string
};